module.exports = __webpack_public_path__ + "img/hero-dropdown-filter-toyota.3e9b3638.png";